module.exports = __webpack_public_path__ + "static/media/nextMobile.600c3dff.svg";